<template>
  <div id="app">
    <Header />
    <router-view/>
    <Footer class="footer"/>
  </div>
</template>

<script>
import Header from '@/components/global/Header'
import Footer from '@/components/global/Footer'

export default {
  name: 'App',
  components: { Header, Footer },
}
</script>

<style>

.carousel-control-next:hover, .carousel-control-prev:hover {
  background-color: whitesmoke;
  opacity: 0.5;
}

</style>
